module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customerAccessUrl":"Customer access URL","copyToClipboard":"Copy text"},"es":{"customerAccessUrl":"URL de acceso para clientes","copyToClipboard":"Copiar texto"}}')
  delete Component.options._Ctor
}
